import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RequestFormService } from '../../service/requestForm/request-form.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-speed-threshold',
  templateUrl: './speed-threshold.component.html',
  styleUrls: ['./speed-threshold.component.scss'],
})
export class SpeedThresholdComponent {
   alerts:any = {
    instructedSpeed: { app: true, email: true },
    thresholdSpeed: { app: true, email: true },
    deviation: { app: true, email: true },
  };

  thresholdValue = 10;
  deviationValue: number = 0;
  instructedDeltaValue: number = 2;
  username: any;

  constructor(
    private requestformservice: RequestFormService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.username = localStorage.getItem('username') || '';

    this.requestformservice
      .getThresholdSpeed(this.username)
      .subscribe((response: any) => {
  
        this.thresholdValue = response.threshold_speed;
        this.deviationValue = response.deviation_value;
        this.instructedDeltaValue = response.instructed_delta_value;

        this.alerts = response.alerts;
      });
  }

  // ✅ Auto disable email when app is OFF
  onAppToggleChange(type: any) {
    if (!this.alerts[type].app) {
      this.alerts[type].email = false;
    }
  }

 saveAlerts() {
  const payload = {
    username: this.username,
    threshold: this.thresholdValue,
    deviationValue: this.deviationValue,
    instructed_delta_value: this.instructedDeltaValue,
    alerts: {
      instructedSpeed: {
        app: !!this.alerts.instructedSpeed?.app,
        email: !!this.alerts.instructedSpeed?.email,
      },
      thresholdSpeed: {
        app: !!this.alerts.thresholdSpeed?.app,
        email: !!this.alerts.thresholdSpeed?.email,
      },
      deviation: {
        app: !!this.alerts.deviation?.app,
        email: !!this.alerts.deviation?.email,
      },
    },
  };

  this.requestformservice.updatedAlerts(payload).subscribe((res: any) => {
    this.toastr.success(res.message);
  });
}
}
